import React from "react";
import { Alert, Box } from "@mui/material";
import { useAuth } from "./AuthContext";

const PowerBIEmbed = () => {
  const { projectKey } = useAuth();
  const isLindt = projectKey === "lindt";
  const isPmi = projectKey === "pmi";
  const pmiPowerBiSrc = "https://app.powerbi.com/view?r=eyJrIjoiN2Y1MDhhNGEtZjA3OS00ODJmLTlhNmQtYzMwYmY5MjIzNmQ2IiwidCI6IjFmMDU4ZWViLWVkYWItNDIxYy04YmFhLTNlOThkZjY2NGNjZiIsImMiOjh9";
  const powerBiSrc = isLindt
    ? "https://app.powerbi.com/reportEmbed?reportId=e261b1d0-80e5-43a4-b6b0-2843a9ab2744&autoAuth=true&ctid=1f058eeb-edab-421c-8baa-3e98df664ccf" 
    : isPmi
      ? pmiPowerBiSrc
      : "https://app.powerbi.com/reportEmbed?reportId=943d6525-84a5-4679-8826-e9fbd272ec6f&autoAuth=true&ctid=1f058eeb-edab-421c-8baa-3e98df664ccf";
  const fallbackUrl = isLindt
    ? "https://www.forloop.ai/app/lindt"
    : "https://www.forloop.ai/app/jti-forloop";

  return (
    <div style={{ height: "100vh", width: "100%" }}>
      {!isPmi && (
        <Box sx={{ p: 2 }}>
          <Alert severity="info" sx={{ mb: 0 }}>
            If PowerBI login is required, the dashboard is also available at{" "}
            <a 
              href={fallbackUrl}
              target="_blank" 
              rel="noopener noreferrer"
              style={{ color: 'inherit', textDecoration: 'underline' }}
            >
              {fallbackUrl}
            </a>{!isLindt ? ", password: camel" : null}
          </Alert>
        </Box>
      )}
      <iframe
        title={isPmi ? "PMI E-com Market Monitoring (shared by Forloop)" : "Power BI Report"}
        width="100%"
        height="85%"
        src={powerBiSrc}
        frameBorder="0"
        allowFullScreen={true}
      ></iframe>
    </div>
  );
};

export default PowerBIEmbed;